export default __webpack_public_path__ + "static/media/mustard.bbde3baf.svg";